import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck, DownloadFileFn} from '../../helpers'
import {
  //#region ExpenseInvoice
  SearchExpenseInvoiceClient,
  DeleteExpenseInvoiceClient,
  ArchivingExpenseInvoiceClient,
  //#endregion

  //#region Bank
  UpdateBankExpenseInvoiceClient,
  CreateBankExpenseInvoiceClient,
  GetBankExpenseInvoiceClient,
  //#endregion

  //#region Detail
  UpdateDetailExpenseInvoiceClient,
  CreateDetailExpenseInvoiceClient,
  GetDetailExpenseInvoiceClient,
  //#endregion

  //#region Fast
  UpdateFastExpenseInvoiceClient,
  CreateFastExpenseInvoiceClient,
  GetFastExpenseInvoiceClient,
  //#endregion

  //#region Sundry
  UpdateSundryExpenseInvoiceClient,
  CreateSundryExpenseInvoiceClient,
  GetSundryExpenseInvoiceClient,
  //#endregion

  //#region Tax
  UpdateTaxExpenseInvoiceClient,
  CreateTaxExpenseInvoiceClient,
  GetTaxExpenseInvoiceClient,
  //#endregion
} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

//#region ExpenseInvoice
const searchExpenseInvoiceClient = new SearchExpenseInvoiceClient(SERVICE_URL)
const deleteExpenseInvoiceClient = new DeleteExpenseInvoiceClient(SERVICE_URL)
const archivingExpenseInvoiceClient = new ArchivingExpenseInvoiceClient(SERVICE_URL)
//#endregion

//#region Bank
const getBankExpenseInvoiceClient = new GetBankExpenseInvoiceClient(SERVICE_URL)
const createBankExpenseInvoiceClient = new CreateBankExpenseInvoiceClient(SERVICE_URL)
const updateBankExpenseInvoiceClient = new UpdateBankExpenseInvoiceClient(SERVICE_URL)
//#endregion

//#region Detail
const getDetailExpenseInvoiceClient = new GetDetailExpenseInvoiceClient(SERVICE_URL)
const createDetailExpenseInvoiceClient = new CreateDetailExpenseInvoiceClient(SERVICE_URL)
const updateDetailExpenseInvoiceClient = new UpdateDetailExpenseInvoiceClient(SERVICE_URL)
//#endregion

//#region Fast
const getFastExpenseInvoiceClient = new GetFastExpenseInvoiceClient(SERVICE_URL)
const createFastExpenseInvoiceClient = new CreateFastExpenseInvoiceClient(SERVICE_URL)
const updateFastExpenseInvoiceClient = new UpdateFastExpenseInvoiceClient(SERVICE_URL)
//#endregion

//#region Sundry
const getSundryExpenseInvoiceClient = new GetSundryExpenseInvoiceClient(SERVICE_URL)
const createSundryExpenseInvoiceClient = new CreateSundryExpenseInvoiceClient(SERVICE_URL)
const updateSundryExpenseInvoiceClient = new UpdateSundryExpenseInvoiceClient(SERVICE_URL)
//#endregion

//#region Tax
const getTaxExpenseInvoiceClient = new GetTaxExpenseInvoiceClient(SERVICE_URL)
const createTaxExpenseInvoiceClient = new CreateTaxExpenseInvoiceClient(SERVICE_URL)
const updateTaxExpenseInvoiceClient = new UpdateTaxExpenseInvoiceClient(SERVICE_URL)
//#endregion

const initialState = {
  loading: false,
  isRedirect: false,
  error: null,
  isDeleted: false,
  isArchived: false,
  excel: null,
  expenseinvoice: null,
  detail: null,
  bank: null,
  fast: null,
  sundry: null,
  tax: null,
}

// Async Thunks
//#region ExpenseInvoice
export const expenseinvoiceGetAll = createAsyncThunk(
  'expenseinvoice/getAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await searchExpenseInvoiceClient.search(
        params.name,
        params.editStartDate,
        params.editEndDate,
        params.projectId,
        params.companyId,
        params.expensePaymentStatusId,
        params.expenseTypeId,
        params.categoryId,
        params.invoiceKindId,
        params.bankId,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      dispatch(setExpenseInvoiceList(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceDelete = createAsyncThunk(
  'expenseinvoice/delete',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await deleteExpenseInvoiceClient.delete(params)
      dispatch(setDeleted(response || true))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceArchiving = createAsyncThunk(
  'expenseinvoice/archiving',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await archivingExpenseInvoiceClient.archive(params)
      dispatch(setArchived(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceExcel = createAsyncThunk(
  'expenseinvoice/excel',
  async ({params, fileName}, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await searchExpenseInvoiceClient.excel(
        params.name,                              
        params.editStartDate,
        params.editEndDate,
        params.projectId,
        params.companyId,
        params.expensePaymentStatusId,
        params.expenseTypeId,
        params.categoryId,
        params.invoiceKindId,
        params.bankId,
        params.items_per_page,
        params.page,
        params.order,
        params.sort
      )
      if (response.data) {
        DownloadFileFn(response.data, fileName)
      }
      dispatch(setExcel(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)
//#endregion

//#region Bank
export const expenseinvoiceBankCreate = createAsyncThunk(
  'expenseinvoice/bank/create',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await createBankExpenseInvoiceClient.create(params)
      dispatch(setBankCreated(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceBankUpdate = createAsyncThunk(
  'expenseinvoice/bank/update',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await updateBankExpenseInvoiceClient.update(params)
      dispatch(setBankUpdated(true))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceBankGetId = createAsyncThunk(
  'expenseinvoice/bank/getById',
  async (id, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await getBankExpenseInvoiceClient.get(id)
      dispatch(setBankDetail(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)
//#endregion

//#region Detail
export const expenseinvoiceDetailCreate = createAsyncThunk(
  'expenseinvoice/detail/create',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await createDetailExpenseInvoiceClient.create(
        params.Name,
        params.InvoiceTypeId,
        params.ProjectId,
        params.CompanyId,
        params.EditDate,
        params.DefermentDate,
        params.InvoiceNumber,
        params.SubTotalPrice,
        params.TotalTax,
        params.TotalDiscount,
        params.GrossTotalPrice,
        params.TotalWitholding,
        params.TotalPrice,
        params.ExpensePaymentStatusId,
        params.FromAccountId,
        params.CheckoutName,
        params.PaymentDate,
        params.ExpenseFile,
        params.RelatedStaffId,
        params.GibInvoiceId,
        params.CategoryId,
        params.InvoiceKindId,
        params.ExpenseInvoiceItems
      )
      dispatch(setDetailCreated(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceDetailUpdate = createAsyncThunk(
  'expenseinvoice/detail/update',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))

      const response = await updateDetailExpenseInvoiceClient.update(
        params.Id,
        params.Name,
        params.ProjectId,
        params.EditDate,
        params.DefermentDate,
        params.InvoiceNumber,
        params.SubTotalPrice,
        params.ExpenseFile,
        params.RelatedStaffId,
        params.TotalTax,
        params.TotalDiscount,
        params.GrossTotalPrice,
        params.TotalWitholding,
        params.TotalPrice,
        params.InvoiceKindId,
        params.ExpenseInvoiceItems
      )
      dispatch(setDetailUpdated(true))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceDetailGetId = createAsyncThunk(
  'expenseinvoice/detail/getById',
  async (id, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await getDetailExpenseInvoiceClient.get(id)
      dispatch(setDetailDetail(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)
//#endregion

//#region Fast
export const expenseinvoiceFastCreate = createAsyncThunk(
  'expenseinvoice/fast/create',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))

      const response = await createFastExpenseInvoiceClient.create(
        params.Name,
        params.ProjectId,
        params.CompanyId,
        params.EditDate,
        params.DefermentDate,
        params.SubTotalPrice,
        params.TotalTax,
        params.TotalPrice,
        params.ExpensePaymentStatusId,
        params.FromAccountId,
        params.CheckoutName,
        params.PaymentDate,
        params.ExpenseFile,
        params.RelatedStaffId,
        params.InvoiceNumber,
        params.CategoryId,
        params.InvoiceKindId
      )
      dispatch(setFastCreated(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceFastUpdate = createAsyncThunk(
  'expenseinvoice/fast/update',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      
      const response = await updateFastExpenseInvoiceClient.update(
        params.Id,
        params.Name,
        params.ProjectId,
        params.EditDate,
        params.DefermentDate,
        params.SubTotalPrice,
        params.ExpenseFile,
        params.InvoiceNumber,
        params.RelatedStaffId,
        params.TotalTax,
        params.TotalPrice,
        params.InvoiceKindId
      )
      dispatch(setFastUpdated(params))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceFastGetId = createAsyncThunk(
  'expenseinvoice/fast/getById',
  async (id, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await getFastExpenseInvoiceClient.get(id)
      dispatch(setFastDetail(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)
//#endregion

//#region Sundry
export const expenseinvoiceSundryCreate = createAsyncThunk(
  'expenseinvoice/sundry/create',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await createSundryExpenseInvoiceClient.create(params)
      dispatch(setSundryCreated(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceSundryUpdate = createAsyncThunk(
  'expenseinvoice/sundry/update',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await updateSundryExpenseInvoiceClient.update(params)
      dispatch(setSundryUpdated({response, params}))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceSundryGetId = createAsyncThunk(
  'expenseinvoice/sundry/getById',
  async (id, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await getSundryExpenseInvoiceClient.get(id)
      dispatch(setSundryDetail(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)
//#endregion

//#region Tax
export const expenseinvoiceTaxCreate = createAsyncThunk(
  'expenseinvoice/tax/create',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await createTaxExpenseInvoiceClient.create(params)
      dispatch(setTaxCreated(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceTaxUpdate = createAsyncThunk(
  'expenseinvoice/tax/update',
  async (params, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await updateTaxExpenseInvoiceClient.update(params)
      dispatch(setTaxUpdated(response, params))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const expenseinvoiceTaxGetId = createAsyncThunk(
  'expenseinvoice/tax/getById',
  async (id, {dispatch}) => {
    try {
      dispatch(setIsRedirect(false))
      dispatch(setLoading(true))
      const response = await getTaxExpenseInvoiceClient.get(id)
      dispatch(setTaxDetail(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)
//#endregion

// Slice
const expenseinvoiceSlice = createSlice({
  name: 'expenseinvoice',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setIsRedirect: (state, action) => {
      state.isRedirect = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setExpenseInvoiceList: (state, action) => {
      state.expenseinvoice = action.payload
      state.loading = false
    },
    setDeleted: (state) => {
      state.isDeleted = true
      state.loading = false
    },
    setArchived: (state) => {
      state.isArchived = true
      state.loading = false
    },
    setExcel: (state, action) => {
      state.excel = action.payload
      state.loading = false
    },
    // Bank
    setBankCreated: (state, action) => {
      state.isRedirect = action.payload
      state.loading = false
    },
    setBankUpdated: (state, action) => {
      state.isRedirect = action.payload
      state.loading = false
    },
    setBankDetail: (state, action) => {
      state.detail = action.payload
      state.loading = false
    },
    // Detail
    setDetailCreated: (state, action) => {
      state.isRedirect = action.payload
      state.loading = false
    },
    setDetailUpdated: (state) => {
      state.isRedirect = true
      state.loading = false
    },
    setDetailDetail: (state, action) => {
      state.detail = action.payload
      state.loading = false
    },
    // Fast
    setFastCreated: (state, action) => {
      state.isRedirect = action.payload
      state.loading = false
    },
    setFastUpdated: (state, action) => {
      state.isRedirect = true
      state.detail = action.payload || (action.meta && action.meta.arg)
      state.loading = false
    },
    setFastDetail: (state, action) => {
      state.detail = action.payload
      state.loading = false
    },
    // Sundry
    setSundryCreated: (state, action) => {
      state.isRedirect = action.payload
      state.loading = false
    },
    setSundryUpdated: (state, action) => {
      state.isRedirect = true
      state.detail = action.payload || (action.meta && action.meta.arg)
      state.loading = false
    },
    setSundryDetail: (state, action) => {
      state.detail = action.payload
      state.loading = false
    },
    // Tax
    setTaxCreated: (state, action) => {
      state.isRedirect = action.payload
      state.loading = false
    },
    setTaxUpdated: (state, action) => {
      state.isRedirect = true
      state.detail = action.payload || (action.meta && action.meta.arg)
      state.loading = false
    },
    setTaxDetail: (state, action) => {
      state.detail = action.payload
      state.loading = false
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('expenseinvoice/') && action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      }
    )
  }
})

export const {
  setLoading,
  setIsRedirect,
  setError,
  setExpenseInvoiceList,
  setDeleted,
  setArchived,
  setExcel,
  setBankCreated,
  setBankUpdated,
  setBankDetail,
  setDetailCreated,
  setDetailUpdated,
  setDetailDetail,
  setFastCreated,
  setFastUpdated,
  setFastDetail,
  setSundryCreated,
  setSundryUpdated,
  setSundryDetail,
  setTaxCreated,
  setTaxUpdated,
  setTaxDetail,
  resetState,
} = expenseinvoiceSlice.actions

// Selectors
export const selectExpenseInvoiceLoading = (state) => state.expenseinvoice.loading
export const selectExpenseInvoiceError = (state) => state.expenseinvoice.error
export const selectExpenseInvoiceList = (state) => state.expenseinvoice.expenseinvoice
export const selectExpenseInvoiceDetail = (state) => state.expenseinvoice.detail
export const selectExpenseInvoiceIsDeleted = (state) => state.expenseinvoice.isDeleted
export const selectExpenseInvoiceIsArchived = (state) => state.expenseinvoice.isArchived
export const selectExpenseInvoiceExcel = (state) => state.expenseinvoice.excel

export default expenseinvoiceSlice.reducer
